// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'bootstrap';

require("@rails/ujs").start()
require("turbolinks").start()
// require("@rails/activestorage").start()
require("channels")
import $ from "jquery"



$(function(){

  function detectHeaderHeight (headerHeight) {
    let height = $(document).scrollTop()
    if (height < headerHeight) {
      $('.header-wrapper').addClass('position-relative').removeClass('position-fixed')
    } else {
      $('.header-wrapper').removeClass('position-relative').addClass('position-fixed')
    }
  }

  let headerHeight = $('header').height();

  detectHeaderHeight(headerHeight);

  $(window).scroll(() => {
    detectHeaderHeight(headerHeight);
  })

  var map = new AMap.Map('location-container', {
    zoom: 17,//级别
    center: [121.58076,31.199289],//中心点坐标
  });

  var marker = new AMap.Marker({
    position: [121.58076,31.199289]//位置
  })
  map.add(marker);//添加到地图

  map.setStatus({scrollWheel: false}) // 禁用鼠标滚轮缩放

  AMap.plugin([
    'AMap.ToolBar'
  ], function(){
      // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
      map.addControl(new AMap.ToolBar());
  });
})
